<body>
    <div class="container">
        <div *ngIf="dataLoaded" class="table-container scrollable-container">
            <!-- <clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'xl'" class="dialog-container"> -->
            <div class="infoDatas">
                <div id="flitrarData" class="divInfoConteudo">
                    <input id="dataInput" type="date" name="dataFiltro" [(ngModel)]="dataFiltro">
                    <button class="select-input" (click)="dataFilter()">Filtrar</button>
                    <!-- <input id="dataMostrar" name="dataMostra" [(ngModel)]="dataMostra" type="text"> -->
                    <span id="dataMostrar">{{ dataMostra | date:'dd/MM/yyyy' }}</span>
                </div>
                <div id="flitrarData" class="divInfoConteudo">
                    <span id="dataMostrar">Ultima atualização</span>
                    <span id="dataMostrar">{{ itemsTimeTable[0]?.lastUpdate | date:'dd/MM/yyyy HH:mm' }}</span>
                    <span id="dataMostrar">{{ itemsTimeTable[0]?.updateBy }}</span>
                </div>
            </div>
            <h3 class="modal-title">VOLUME DE RECEBIMENTO LCB</h3>
            <br>
            <div class="modal-body">
                <form class="inputs">
                    <div *ngIf="dataLoaded" class="table-container scrollable-container">
                        <table class="geralTable">
                            <thead class="sticky-header">
                                <tr>
                                    <th class="col-op-width titulos-inserir">
                                        <span class="semFundo">OPERAÇÃO</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">TRANSPORTADORA</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">VEÍCULOS (QT.)</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">PALLETS (QT.)</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">MÉDIA (PALLET/VEÍCULO)</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="corpoTimeTable">
                                    <td class="centralizado">
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Direto Extra:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Diretos:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Aéreo:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">FRETE EXTRA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Container:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo CRAGEA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo Santos:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo CRAGEA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Container:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run São
                                                    Paulo e Sul:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run Sul:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>     -->
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run
                                                    Argentina:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run Interior/SP e
                                                    Minas Gerais:
                                                </abbr>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="centralizado">
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">EXTRA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">NORMAL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">ASA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">FRETE EXTRA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">LOTS:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">SUZAN:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">SUZAN:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">TLOG:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">TLOG:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">JSL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">JSL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">RITMO:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">TCM:
                                                </abbr>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="centralizado">
                                        <div class="inputValue marginCima">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosFE" [(ngModel)]="volRecebimento.qtVeiculosFE"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)" -->
                                            <!-- (blur)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosDiretos" [(ngModel)]="volRecebimento.qtVeiculosDiretos"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosAereo" [(ngModel)]="volRecebimento.qtVeiculosAereo"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosFRETE_EXTRA"
                                                [(ngModel)]="volRecebimento.qtVeiculosFRETE_EXTRA"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaLots', volRecebimento.qtPalletsFRETE_EXTRA, volRecebimento.qtVeiculosFRETE_EXTRA)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaLots', volRecebimento.qtPalletsFRETE_EXTRA, volRecebimento.qtVeiculosFRETE_EXTRA)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosSantosLots"
                                                [(ngModel)]="volRecebimento.qtVeiculosSantosLots"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)"> -->
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosCrageaSuzan"
                                                [(ngModel)]="volRecebimento.qtVeiculosCrageaSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosSantosSuzan"
                                                [(ngModel)]="volRecebimento.qtVeiculosSantosSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)">
                                        </div>
                                        <hr> -->
                                        <!-- <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosCrageaTLOG"
                                                [(ngModel)]="volRecebimento.qtVeiculosCrageaTLOG"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaTLOG', volRecebimento.qtPalletsCrageaTLOG, volRecebimento.qtVeiculosCrageaTLOG)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaTLOG', volRecebimento.qtPalletsCrageaTLOG, volRecebimento.qtVeiculosCrageaTLOG)">
                                        </div>
                                        <hr> -->
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosSantosTLOG"
                                                [(ngModel)]="volRecebimento.qtVeiculosSantosTLOG"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaSantosTLOG', volRecebimento.qtPalletsSantosTLOG, volRecebimento.qtVeiculosSantosTLOG)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosTLOG', volRecebimento.qtPalletsSantosTLOG, volRecebimento.qtVeiculosSantosTLOG)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosMRjsl" [(ngModel)]="volRecebimento.qtVeiculosMRjsl"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"> -->
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosMRjsl"
                                                [(ngModel)]="volRecebimento.qtVeiculosMRjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)">
                                        </div>
                                        <hr> -->
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosARGjsl" [(ngModel)]="volRecebimento.qtVeiculosARGjsl"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtVeiculosMRtcm" [(ngModel)]="volRecebimento.qtVeiculosMRtcm"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)"> -->
                                        </div>
                                    </td>
                                    <td class="centralizado">
                                        <div class="inputValue marginCima">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsFE" [(ngModel)]="volRecebimento.qtPalletsFE" step="0.01"
                                                min="0" (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsDiretos" [(ngModel)]="volRecebimento.qtPalletsDiretos"
                                                step="0.01" min="0" (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsAereo" [(ngModel)]="volRecebimento.qtPalletsAereo"
                                                step="0.01" min="0" (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsFRETE_EXTRA"
                                                [(ngModel)]="volRecebimento.qtPalletsFRETE_EXTRA" step="0.01" min="0"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsSantosLots"
                                                [(ngModel)]="volRecebimento.qtPalletsSantosLots" step="0.01" min="0"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)"> -->
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsCrageaSuzan"
                                                [(ngModel)]="volRecebimento.qtPalletsCrageaSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsSantosSuzan"
                                                [(ngModel)]="volRecebimento.qtPalletsSantosSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)">
                                        </div>
                                        <hr> -->
                                        <!-- <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsCrageaTLOG"
                                                [(ngModel)]="volRecebimento.qtPalletsCrageaTLOG"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaTLOG', volRecebimento.qtPalletsCrageaTLOG, volRecebimento.qtVeiculosCrageaTLOG)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaTLOG', volRecebimento.qtPalletsCrageaTLOG, volRecebimento.qtVeiculosCrageaTLOG)">
                                        </div>
                                        <hr> -->
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsSantosTLOG"
                                                [(ngModel)]="volRecebimento.qtPalletsSantosTLOG" step="0.01" min="0"
                                                (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaSantosTLOG', volRecebimento.qtPalletsSantosTLOG, volRecebimento.qtVeiculosSantosTLOG)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosTLOG', volRecebimento.qtPalletsSantosTLOG, volRecebimento.qtVeiculosSantosTLOG)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsMRjsl" [(ngModel)]="volRecebimento.qtPalletsMRjsl"
                                                step="0.01" min="0" (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"> -->
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsMRjsl"
                                                [(ngModel)]="volRecebimento.qtPalletsMRjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)">
                                        </div>                                      
                                        <hr> -->
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsARGjsl" [(ngModel)]="volRecebimento.qtPalletsARGjsl"
                                                step="0.01" min="0" (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)"> -->
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly type="number" [disabled]="isAdminEnabled" id="quantidades"
                                                name="qtPalletsMRtcm" [(ngModel)]="volRecebimento.qtPalletsMRtcm"
                                                step="0.01" min="0" (focus)="selecionarTexto($event)">
                                            <!-- (keydown)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)"> -->
                                        </div>
                                    </td>
                                    <td class="centralizado">
                                        <div class="inputValue marginCima">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaFE" [ngModel]="volRecebimento.qtMediaFE| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaDiretos"
                                                [ngModel]="volRecebimento.qtMediaDiretos| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaAereo"
                                                [ngModel]="volRecebimento.qtMediaAereo| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaFRETE_EXTRA" [ngModel]="volRecebimento.qtMediaFRETE_EXTRA"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaSantosLots"
                                                [ngModel]="volRecebimento.qtMediaSantosLots| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaCrageaSuzan" [ngModel]="volRecebimento.qtMediaCrageaSuzan"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaSantosSuzan" [ngModel]="volRecebimento.qtMediaSantosSuzan"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr> -->
                                        <!-- <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaCrageaTLOG"
                                                [ngModel]="volRecebimento.qtMediaCrageaTLOG"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr> -->
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaSantosTLOG"
                                                [ngModel]="volRecebimento.qtMediaSantosTLOG| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaMRjsl"
                                                [ngModel]="volRecebimento.qtMediaMRjsl| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades" name="qtMediaMRjsl"
                                                [ngModel]="volRecebimento.qtMediaMRjsl"
                                                (focus)="selecionarTexto($event)">
                                        </div>                                     
                                        <hr> -->
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaARGjsl"
                                                [ngModel]="volRecebimento.qtMediaARGjsl| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input readonly [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaMRtcm"
                                                [ngModel]="volRecebimento.qtMediaMRtcm| number:'1.2-2'"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="dataLoaded" class="table-container scrollable-container">
                        <table class="geralTable">
                            <thead class="sticky-header">
                                <tr class="linhaTotais">
                                    <th class="titulos-inserir totais" colspan="3">
                                        <span class="semFundo">TOTAL</span>
                                    </th>
                                    <th class="titulos-inserir totais">
                                        <div class="inputValue marginCimaTotais">
                                            <span>VEÍCULOS</span>
                                            <input [disabled]="true" type="text" name="veicTotal"
                                                [(ngModel)]="volRecebimento.veicTotal"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </th>
                                    <th class="titulos-inserir totais">
                                        <div class="inputValue marginCimaTotais">
                                            <span>PALLETS</span>
                                            <input [disabled]="true" type="text" name="palletsTotal"
                                                [(ngModel)]="volRecebimento.palletsTotal"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </th>
                                    <th class="titulos-inserir totais">
                                        <div class="inputValue marginCimaTotais">
                                            <span>MÉDIA</span>
                                            <input [disabled]="true" type="text" name="mediaTotal"
                                                [ngModel]="volRecebimento.mediaTotal | number:'1.2-2'"
                                                (ngModelChange)="volRecebimento.mediaTotal = $event"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="modal-div botoes">
                        <button *ngIf="usuarioLogado.role == 9" class="modal-button" type="button"
                            (click)="salvar(volRecebimento)">Save</button>
                        <!-- <button class="modal-button" type="button" (click)="cancel()">Cancel</button> -->
                    </div>
                </form>
            </div>
            <!-- </clr-modal> -->

        </div>
    </div>
</body>


<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>